module.exports = __webpack_public_path__ + "img/jg_hover.ee83efaa.png";